/**
 * Tiny inline SVG sparkline — reusable across Tenants / Programmes / any
 * trend surface. Zero dependencies, accessible, deterministic sizing.
 */
export function Sparkline({
  values,
  width = 120,
  height = 28,
  pad = 2,
  color = "#7737f6",
  fillOpacity = 0.10,
  ariaLabel = "trend",
  testid = "sparkline",
}) {
  if (!Array.isArray(values) || values.length < 2) {
    return <span className="text-xs text-slate-400" data-testid={`${testid}-empty`}>—</span>;
  }
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const span = max - min || 1;
  const stepX = (width - pad * 2) / (values.length - 1);
  const pts = values.map((v, i) => {
    const x = pad + i * stepX;
    const y = height - pad - ((v - min) / span) * (height - pad * 2);
    return [x, y];
  });
  const line = pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = `${pad},${height - pad} ${line} ${(width - pad).toFixed(1)},${height - pad}`;
  const [lx, ly] = pts[pts.length - 1];
  const last = values[values.length - 1];
  const first = values[0];
  const delta = last - first;
  return (
    <svg
      width="100%"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      style={{ maxWidth: width, minWidth: 40 }}
      className="overflow-visible"
      role="img"
      aria-label={`${ariaLabel}: ${first.toFixed(2)} → ${last.toFixed(2)} (delta ${delta >= 0 ? "+" : ""}${delta.toFixed(2)})`}
      data-testid={testid}
    >
      <polygon points={area} fill={color} fillOpacity={fillOpacity} />
      <polyline points={line} fill="none" stroke={color} strokeWidth="1.5"
                strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lx} cy={ly} r="2.4" fill={color} />
    </svg>
  );
}
